import { useEffect, useState } from "react";
import { Images, X } from "lucide-react";
import { api, imageUrl } from "../../lib/api";

const COLOR = { wit: "Wit", cremewit: "Crèmewit", antraciet: "Antraciet", zwart: "Zwart", houtlook: "Houtlook" };

// Gekozen inspiratiebeeld (?inspiratie=INS-…) of vergelijkbaar project (?project=slug) dat met de aanvraag meegaat.
export const useWizardReference = (params) => {
  const [ref, setRef] = useState(null);
  useEffect(() => {
    let on = true;
    if (/^INS-[A-F0-9]{6}$/.test(params.inspiratie || "")) {
      api.get("/inspiration").then((r) => {
        const it = (r.data || []).find((x) => x.ref === params.inspiratie);
        if (on && it) setRef({ kind: "Inspiratiebeeld", title: it.title, code: it.ref, image: it.image.path, color: COLOR[it.color], text: `Inspiratiebeeld ${it.ref}: ${it.title}` });
      }).catch(() => {});
    } else if (/^[a-z0-9-]{2,120}$/.test(params.project || "")) {
      api.get(`/projects/${params.project}`).then((r) => {
        const p = r.data;
        if (on && p) setRef({ kind: "Vergelijkbaar project", title: p.title, code: p.plaats, image: p.hero_image?.path, text: `Project: ${p.title} (/projecten/${p.slug})` });
      }).catch(() => {});
    }
    return () => { on = false; };
  }, [params.inspiratie, params.project]);
  return [ref, () => setRef(null)];
};

export const ReferenceLinked = ({ refItem, onRemove }) => (
  <div className="mb-6 flex items-center gap-3 rounded-2xl border border-maas/25 bg-maas-soft/60 p-3 pr-4" data-testid="wizard-reference">
    {refItem.image ? <img src={imageUrl(refItem.image)} alt="" className="h-14 w-14 shrink-0 rounded-xl object-cover" />
      : <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-white text-maas"><Images className="h-6 w-6" aria-hidden="true" /></span>}
    <div className="min-w-0 flex-1">
      <p className="text-[12px] font-semibold uppercase tracking-[0.12em] text-maas">{refItem.kind}</p>
      <p className="truncate text-[15px] font-semibold text-ink" data-testid="wizard-reference-title">{refItem.title}</p>
      {refItem.code && <p className="text-[13px] text-slate-500">{refItem.code} · gaat mee met uw aanvraag</p>}
    </div>
    <button type="button" onClick={onRemove} className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-slate-500 hover:bg-white hover:text-ink" aria-label="Verwijderen uit aanvraag" data-testid="wizard-reference-remove">
      <X className="h-4 w-4" />
    </button>
  </div>
);
